import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateSearchBoxText',
    (scenarioId: SearchScenarioId, text: string) => {
        getScenarioStore(scenarioId).searchText = text;
    }
);
